

import { useEffect, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import { AvatarScreen } from '../../ui';
import { BotonesAndCargando } from '../../components/botones';
import { useImagenStore } from '../../../stores';


const initUser = {
    nombre: "",
    cedula: "",
    ciudad: "",
    direccion: "",
    movil: "",
    establecimiento: "",
    profesion: "",
    email: "",
};





export const FromPerfilUsuario = ({ funcion, data, cargando }) => {


    const { valorImagen } = useImagenStore();
    const [formUsuario, setFormUsuario ] = useState( initUser );
    const { nombre, cedula, ciudad, direccion, movil, establecimiento, profesion, email } = formUsuario;


    useEffect( () => {
        if( data ){
            setFormUsuario({ ...data });
            valorImagen(data.img)
        }
    }, [data]);



    const handleInputChange = ({ target }) => {
        setFormUsuario({
            ...formUsuario,
            [target.name]: target.value
        });
    }



    return (
        <>
        <AvatarScreen carpeta="usuarios" />

        <form onSubmit={(e) => funcion(e, formUsuario) } >
            <Grid container spacing={3} sx={{mt:1}}>
                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Nombre Usuario'
                        type='text'
                        placeholder='Nombre Usuario'
                        fullWidth
                        name="nombre"
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Cedula Usuario'
                        type='text'
                        placeholder='Cedula Usuario'
                        fullWidth
                        name="cedula"
                        value={ cedula }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Correo Electronico'
                        type='text'
                        placeholder='Correo Electronico'
                        fullWidth
                        name="email"
                        value={ email }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Movil'
                        type='text'
                        placeholder='Movil'
                        fullWidth
                        name="movil"
                        value={ movil }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Establecimiento'
                        type='text'
                        placeholder='Establecimiento'
                        fullWidth
                        name="establecimiento"
                        value={ establecimiento }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Profesión'
                        type='text'
                        placeholder='Profesión'
                        fullWidth
                        name="profesion"
                        value={ profesion }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField 
                        variant="outlined"
                        label='Ciudad'
                        type='text'
                        placeholder='Ciudad'
                        fullWidth
                        name="ciudad"
                        value={ ciudad }
                        onChange={ handleInputChange } 
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <TextField required
                        variant="outlined"
                        label='Dirección'
                        type='text'
                        placeholder='Dirección'
                        fullWidth
                        name="direccion"
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>
            </Grid>

            <Grid container sx={{mb:3, mt:4, display:'flex', justifyContent:'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                    <BotonesAndCargando
                        cargando={cargando}
                        titulo='Editar Mi Perfil'
                        titulo2="Loading..."
                        icon1="save"
                        icon2="save"
                        esSubmit
                    />
                </Grid>
            </Grid>
        </form>
        </>
    )


}
